import { gql, useMutation } from "@apollo/client";

const UPDATE_USER_EMAIL = gql`
  mutation UpdateUserEmail($input: UpdateUserEmailInput!) {
    updateUserEmail(input: $input) {
      email
    }
  }
`;

export interface UpdateUserEmailData {
  updateUserEmail: { email: string };
}

export interface UpdateUserEmailVars {
  input: {
    email: string;
  };
}

export const useUpdateUserEmailMutation = () =>
  useMutation<UpdateUserEmailData, UpdateUserEmailVars>(UPDATE_USER_EMAIL);
